module.exports = __webpack_public_path__ + "media/images/kids2-e77007be659b36626c7d3f83ef904a24.jpg";